import { IBuilderOptions } from "./builder-models";
import { simpleClone } from "../common/common-service-utils";

//   Legacy options missing need adding
//   The problem with merge is that it will overwrite the existing values
//   with potentially garbage values.
export function cleanServerResponse(
  builderOptions: IBuilderOptions
): IBuilderOptions {
  const builderOptionsInternal: IBuilderOptions = simpleClone(builderOptions);

  // Guard against undefined/null server response
  if (!builderOptionsInternal) {
    return {} as IBuilderOptions;
  }

  if (!builderOptionsInternal.autoEntries) {
    builderOptionsInternal.autoEntries = {
      selectedTargetComp: {
        id: 0,
        name: "",
        timeTronicsUrl: "",
      },
      targetable: {
        allowedSources: [],
        enabled: false,
      },
    };
  }
  if (!builderOptionsInternal.level) {
    builderOptionsInternal.level = "";
  }
  if (builderOptionsInternal.pbMandatory === undefined) {
    builderOptionsInternal.pbMandatory = false;
  }
  if (builderOptionsInternal.pbMandatory === undefined) {
    builderOptionsInternal.pbMandatory = false;
  }
  if (!builderOptionsInternal.cloneInfo) {
    builderOptionsInternal.cloneInfo = {
      fromId: 0,
    };
  }

  if (!builderOptionsInternal.flyerInfo) {
    builderOptionsInternal.flyerInfo = "";
  }
  if (!builderOptionsInternal.timetable) {
    builderOptionsInternal.timetable = "provisional";
  }

  if (!builderOptionsInternal.allowAdd) {
    builderOptionsInternal.allowAdd = {
      unregistered: false,
      registered: true,
      international: false,
    };
  }

  if (!builderOptionsInternal.simpleRegistration) {
    builderOptionsInternal.simpleRegistration = {
      enabled: false,
      ui: {
        showClub: false,
        showSchool: false,
        showDobYearOnly: false,
      },
    };
  }

  //  Coming up sometimes as a number, sometimes as a string
  const paymentCode: string | number = builderOptionsInternal.paymentCode as
    | string
    | number;

  //  sometimes not present
  if (!builderOptionsInternal.paymentCode) {
    builderOptionsInternal.paymentCode = "";
  }

  if (typeof paymentCode === "number") {
    builderOptionsInternal.paymentCode = paymentCode.toString();
  }

  const bibNos: string | number = builderOptionsInternal.bibNos as
    | string
    | number;
  if (typeof bibNos === "number") {
    builderOptionsInternal.bibNos = builderOptionsInternal.bibNos.toString();
  }

  const contactTel: string | number = builderOptionsInternal.contact.tel as
    | string
    | number;
  if (typeof contactTel === "number") {
    builderOptionsInternal.contact.tel = contactTel.toString();
  }

  if (!builderOptionsInternal.helpText.athletes) {
    builderOptionsInternal.helpText.athletes = "";
  }

  if (typeof builderOptionsInternal.useV2Routes === undefined) {
    builderOptionsInternal.useV2Routes = true;
  }

  // add useNewResults if not present
  if (builderOptionsInternal.useNewResults === undefined) {
    builderOptionsInternal.useNewResults = false;
  }

  if (builderOptionsInternal.socialMediaCapture === undefined) {
    builderOptionsInternal.socialMediaCapture = {
      enabled: false,
    };
  }

  if (builderOptionsInternal.teamManager === undefined) {
    builderOptionsInternal.teamManager = {
      enabled: true,
    };
  }

  if (builderOptionsInternal.allowAnonymous === undefined) {
    builderOptionsInternal.allowAnonymous = true;
  }

  if (builderOptionsInternal.tickets === undefined) {
    builderOptionsInternal.tickets = {
      enabled: false,
      requiresEntry: false,
    };
  } else {
    // Merge default values into existing tickets object
    if (builderOptionsInternal.tickets.enabled === undefined) {
      builderOptionsInternal.tickets.enabled = false;
    }
    if (builderOptionsInternal.tickets.requiresEntry === undefined) {
      builderOptionsInternal.tickets.requiresEntry = false;
    }
  }

  // check bibSort1-6 exist
  if (!builderOptionsInternal.bibSort1) {
    builderOptionsInternal.bibSort1 = "";
  }
  if (!builderOptionsInternal.bibSort2) {
    builderOptionsInternal.bibSort2 = "";
  }
  if (!builderOptionsInternal.bibSort3) {
    builderOptionsInternal.bibSort3 = "";
  }
  if (!builderOptionsInternal.bibSort4) {
    builderOptionsInternal.bibSort4 = "";
  }
  if (!builderOptionsInternal.bibSort5) {
    builderOptionsInternal.bibSort5 = "";
  }
  if (!builderOptionsInternal.bibSort6) {
    builderOptionsInternal.bibSort6 = "";
  }

  if (!builderOptionsInternal.familyPrice) {
    builderOptionsInternal.familyPrice = {
      enabled: false,
      priceId: 0,
      targetTotal: 0,
      minEntries: 0,
      maxEntries: 0,
      minDifferentOriginalPrices: 0,
      maxEachPrice: 0,
      includeTeamEntries: false,
      includeDiscountedEntries: false,
      label: "Family Discount",
    };
  }

  return builderOptionsInternal;
}
